(() => {
  const root = document.querySelector('[data-veel-liefs-addon]');
  if (!root) return;

  const toggle    = root.querySelector('[data-veel-liefs-toggle]');
  const content   = root.querySelector('[data-veel-liefs-content]');
  const messageEl = root.querySelector('[data-veel-liefs-message]');
  const countEl   = root.querySelector('[data-veel-liefs-count]');
  const limitEl   = root.querySelector('[data-veel-liefs-limit]');
  const statusEl  = root.querySelector('[data-veel-liefs-status]');
  const wordError = root.querySelector('[data-veel-liefs-word-error]');

  // ─── helpers ────────────────────────────────────────────────
  const wordCount = (t) => (t || '').trim().split(/\s+/).filter(Boolean).length;
  const getSelected = () => root.querySelector('input[name="veel_liefs_variant"]:checked');
  const currentLimit = () => Number(getSelected()?.dataset.wordLimit || 30);

  const findAtcButton = () =>
    document.querySelector('product-form button[name="add"]') ||
    document.querySelector('form[action*="/cart/add"] button[name="add"]');

  let atcButton = null;
  let originalAtcHTML = '';

  const initAtcButton = () => {
    const btn = findAtcButton();
    if (btn && btn !== atcButton) {
      atcButton = btn;
      originalAtcHTML = btn.innerHTML;
    }
  };

  setTimeout(initAtcButton, 300);

  // ─── toggle ─────────────────────────────────────────────────
  toggle.addEventListener('change', () => {
    content.style.display = toggle.checked ? 'block' : 'none';
    if (toggle.checked) { initAtcButton(); updateWordCount(); }
    updateAtcButton();
  });

  // ─── woordenteller ──────────────────────────────────────────
  const updateWordCount = () => {
    const limit = currentLimit();
    const wc    = wordCount(messageEl.value);
    limitEl.textContent = String(limit);
    countEl.textContent = String(wc);
    const over = wc > limit;
    wordError.style.display = over ? 'block' : 'none';
    wordError.textContent = over
      ? `Te veel woorden (${wc}/${limit}). Verwijder nog ${wc - limit} woord${wc - limit > 1 ? 'en' : ''}.`
      : '';
  };

  root.addEventListener('change', (e) => {
    if (e.target?.matches('input[name="veel_liefs_variant"]')) updateWordCount();
  });
  messageEl.addEventListener('input', updateWordCount);

  // ─── knoptekst aanpassen ────────────────────────────────────
  const updateAtcButton = () => {
    initAtcButton();
    if (!atcButton) return;
    atcButton.innerHTML = toggle.checked
      ? "<span>Aan winkelwagen toevoegen: kaars + kaartje</span>"
      : originalAtcHTML;
  };

  // ─── teller rechtsboven bijwerken ───────────────────────────
  const updateCartCount = () => {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        document
          .querySelectorAll('.cart-count-bubble span, [data-cart-count]')
          .forEach((el) => { el.textContent = String(cart.item_count); });
      })
      .catch(() => {});
  };

  // ─── HOOFDLOGICA: onderschep klik in capture-fase ───────────
  document.addEventListener('click', async (e) => {
    if (!toggle.checked) return;

    const btn = e.target.closest(
      'product-form button[name="add"], form[action*="/cart/add"] button[name="add"]'
    );
    if (!btn) return;

    const limit   = currentLimit();
    const message = (messageEl.value || '').trim();
    const wc      = wordCount(message);
    if (wc > limit) { updateWordCount(); e.preventDefault(); e.stopImmediatePropagation(); return; }

    e.preventDefault();
    e.stopImmediatePropagation();

    const selected = getSelected();
    if (!selected) return;

    const productForm  = btn.closest('form') || document.querySelector('form[action*="/cart/add"]');
    const variantInput = productForm?.querySelector('[name="id"]');
    const variantId    = variantInput?.value;
    const qty          = Number(productForm?.querySelector('[name="quantity"]')?.value || 1);

    if (!variantId) {
      statusEl.textContent = '⚠️ Kon product niet vinden. Probeer opnieuw.';
      statusEl.style.color = 'rgb(180,0,0)';
      return;
    }

    btn.disabled = true;
    btn.innerHTML = '<span>Bezig met toevoegen…</span>';
    statusEl.textContent = '';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: Number(variantId), quantity: qty },
            {
              id: Number(selected.value),
              quantity: 1,
              properties: {
                'Handgeschreven boodschap': message || '(geen boodschap ingevuld)',
                'Formaat': selected.dataset.variantTitle || '',
              },
            },
          ],
        }),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Toevoegen mislukt');
      }

      statusEl.textContent = '✅ Kaars + kaartje toegevoegd aan je winkelwagen!';
      statusEl.style.color = '#2a7a2a';
      btn.innerHTML        = '<span>✅ Toegevoegd!</span>';

      updateCartCount();

      setTimeout(() => {
        btn.disabled  = false;
        btn.innerHTML = "<span>Aan winkelwagen toevoegen: kaars + kaartje</span>";
      }, 3000);

    } catch (err) {
      btn.disabled  = false;
      btn.innerHTML = "<span>Aan winkelwagen toevoegen: kaars + kaartje</span>";
      statusEl.textContent = `⚠️ ${err.message || 'Er ging iets mis. Probeer opnieuw.'}`;
      statusEl.style.color = 'rgb(180,0,0)';
    }

  }, true);

  updateWordCount();
})();